import styled from 'styled-components';

import { translate } from '../../helpers/translate.helper';
import { LabelText } from '../../LabelText/LabelText';
import { Box } from '../../ui/Box';
import { theme } from '../../ui/theme';
import { PriceHeading } from '../common/PriceHeading';
import { TotalRowTd } from '../components/TotalRowTd';
import { useProductTableConfig } from '../hooks/useProductTableConfig';

const CustomTr = styled.tr`
    border-top: 1px solid ${theme.colors.border.subtle} !important;
    border-right: 1px solid ${theme.colors.border.subtle} !important;
    border-left: 1px solid ${theme.colors.border.subtle} !important;
`;

export const TotalHeaderRow = () => {
    const { editPrices } = useProductTableConfig();
    return (
        <CustomTr>
            <TotalRowTd colSpan={5} />

            <TotalRowTd>
                <Box display="flex" justifyContent="flex-end">
                    <LabelText>{translate('order.volume')}</LabelText>
                </Box>
            </TotalRowTd>

            <TotalRowTd />

            <TotalRowTd>
                <LabelText>
                    <PriceHeading align={editPrices ? 'left' : 'right'} />
                </LabelText>
            </TotalRowTd>

            <TotalRowTd>
                <Box display="flex" justifyContent="flex-end">
                    <LabelText>{translate('order.total')}</LabelText>
                </Box>
            </TotalRowTd>

            <TotalRowTd />
        </CustomTr>
    );
};
